import React, { Fragment, useEffect } from 'react';
import { Portal } from 'react-portal';

function ToastNotification({ options, closeToast }) {

    useEffect(() => {
        if (options.timeout) timeoutCloseToast();
    }, [])

    const timeoutCloseToast = () => {
        setTimeout(() => {
            closeToast();
        }, 2000)
    }

    const getClassName = () => {
        let className = ""
        switch (options.type) {
            case "success":
                className = "c-toast-notification--success";
                break;
            case "warning":
                className = "c-toast-notification--warning";
                break;
            case "error":
                className = "c-toast-notification--error";
                break;
            default:
                break;
        }
        return className;
    }

    return (
        <Portal>
            <aside id="js-toast-notifications" className="c-toast-notifications  js-toast-notifications" aria-label={options.title}>
                <article className={"c-toast-notification " + getClassName()} aria-live="polite" role="status">
                    <div className="c-toast-notification__content">
                        <div className="c-toast-notification__header">
                            <p><strong>{options.title}</strong></p>
                        </div>
                        <div className="c-toast-notification__body">
                            <p>{options.text}</p>
                        </div>
                        <button className="c-toast-notification__close  c-icon  c-icon--[semantic-close]" type="button" title={options.closeText} onClick={closeToast}></button>
                    </div>
                </article>
            </aside>
        </Portal>
    );
}

export default ToastNotification;